// extracted by mini-css-extract-plugin
module.exports = {"Root":"Base_Root__3CQAv","Additional":"Base_Additional__2ZdY4"};